<form [formGroup]="formGroup">
  <div class="space-y-2">
    <div class="col-span-full">
      <app-text-area
        [label]="'Cause (Farmer)'"
        [fieldConfigurationAddress]="'dtc.causeFarmer'"
        formControlName="causeFarmer"
        [reset$]="resetFieldTracking$"
        [rows]="3"
        [readonly]="!editReviewEnabled || !item"
      ></app-text-area>
    </div>

    <div class="col-span-full">
      <app-text-area
        [label]="'Remedy (Farmer)'"
        [fieldConfigurationAddress]="'dtc.remedyFarmer'"
        formControlName="remedyFarmer"
        [reset$]="resetFieldTracking$"
        [rows]="3"
        [readonly]="!editReviewEnabled || !item"
      ></app-text-area>
    </div>
    <div class="col-span-full">
      <app-text-area
        [label]="'Cause (Dealer)'"
        [fieldConfigurationAddress]="'dtc.causeDealer'"
        formControlName="causeDealer"
        [reset$]="resetFieldTracking$"
        [rows]="3"
        [readonly]="!editReviewEnabled || !item"
      ></app-text-area>
    </div>

    <div class="col-span-full">
      <app-text-area
        [label]="'Remedy (Dealer)'"
        [fieldConfigurationAddress]="'dtc.remedyDealer'"
        formControlName="remedyDealer"
        [reset$]="resetFieldTracking$"
        [rows]="3"
        [readonly]="!editReviewEnabled || !item"
      ></app-text-area>
    </div>

    <div class="col-span-full">
      <app-text-area
        [label]="'Cause (Intern)'"
        [fieldConfigurationAddress]="'dtc.causeIntern'"
        formControlName="causeIntern"
        [reset$]="resetFieldTracking$"
        [rows]="3"
        [readonly]="!editReviewEnabled || !item"
      ></app-text-area>
    </div>

    <div class="col-span-full">
      <app-text-area
        [label]="'Remedy (Intern)'"
        [fieldConfigurationAddress]="'dtc.remedyIntern'"
        formControlName="remedyIntern"
        [reset$]="resetFieldTracking$"
        [rows]="3"
        [readonly]="!editReviewEnabled || !item"
      ></app-text-area>
    </div>

    <div class="col-span-full">
      <app-text-area
        [label]="'Review notes'"
        [fieldConfigurationAddress]="'dtc.internalNotes'"
        [fieldIsRequired]="false"
        formControlName="reviewNotes"
        [reset$]="resetFieldTracking$"
        [readonly]="!editReviewEnabled || !item"
      ></app-text-area>
    </div>
  </div>

  <div class="col-span-full flex justify-end">
    @if (showCreateButton) {
      <div>
        <button
          class="crud-btn-sidebar"
          [disabled]="createReviewDisabled"
          (click)="emitReviewUpserted()"
          appAgentAction
          agent="review-request-fields-create"
          businessObject="reviewRequest"
          action="create"
        >
          <app-add></app-add>
        </button>
      </div>
    } @else {
      <button
        type="button"
        [disabled]="formGroup.invalid || !item || !editReviewEnabled"
        (click)="emitReviewUpserted()"
        class="crud-btn-sidebar"
        appAgentAction
        agent="review-request-fields-save"
        businessObject="reviewRequest"
        [businessId]="$safeNavigationMigration(item?.id)"
        action="save"
      >
        <app-floppy-icon></app-floppy-icon>
      </button>
      <button
        type="button"
        class="crud-btn-sidebar bottom-48"
        [disabled]="!editReviewEnabled"
        (click)="emitReviewDiscarded()"
        appAgentAction
        agent="review-request-fields-discard"
        businessObject="reviewRequest"
        [businessId]="$safeNavigationMigration(item?.id)"
        action="discard"
      >
        <app-delete-icon></app-delete-icon>
      </button>
    }
  </div>
</form>
